export type AxNewsSectionKey = "use-case" | "trend" | "pwc-solutions";

export interface AxNewsItem {
  id: string;
  section: AxNewsSectionKey;
  image: string;
  title: string;
  description: string;
  body: string;
  date: string;
  href?: string;
}

export interface AxNewsSectionMeta {
  key: AxNewsSectionKey;
  title: string;
  badgeLabel: string;
}

export const AX_NEWS_SECTIONS: Record<AxNewsSectionKey, AxNewsSectionMeta> = {
  "use-case":      { key: "use-case",      title: "AI Use Case",            badgeLabel: "AI Use Case" },
  "trend":         { key: "trend",         title: "AX Trend",               badgeLabel: "AX Trend" },
  "pwc-solutions": { key: "pwc-solutions", title: "PwC Digital Solutions",  badgeLabel: "PwC Digital Solutions" },
};
